import * as React from 'react';
import {
  List,
  ListItem,
  ListItemText,
  ListItemTitle,
  ListItemActions,
} from '../../../Components';
import { observer } from 'mobx-react';
import { Tag } from '../../../Components/Tag/Tag';
import { OrientadorModel, ParametroPreProjetoModel } from '../../../Store';
import styled from 'styled-components';
import InstrucoesPreProjetoCard from './InstrucoesPreProjetoCard'

/*
  interfaces
*/
interface IProps {
  preprojetos: OrientadorModel[];
  faseAtual: number
  parametros: ParametroPreProjetoModel
}

const StyledTags = styled.div`
  flex-direction: row;
`;

const StyledItem = styled(ListItem)`
  display: flex;
`;

@observer
export class PreProjetoList extends React.Component<IProps> {

  render() {
    const { preprojetos, faseAtual, parametros } = this.props;

    return (
      <>
        <InstrucoesPreProjetoCard faseAtual={faseAtual} parametros={parametros} />
        <List showBorder={false}>
          {preprojetos &&
            preprojetos.map((m, i) => (
              <StyledItem
                key={i}
                onClick={() => {
                  window.location.pathname =
                    `professor/preprojeto/${m.preProjeto.id}`;
                }}
              >
                <ListItemTitle>{m.preProjeto.aluno.nome}</ListItemTitle>
                <ListItemText>{m.preProjeto.titulo}</ListItemText>
                <ListItemActions>
                  <StyledTags>
                    {(() => {
                      switch (m.conviteAceito) {
                        case true:
                          return <Tag color='approvedColor'>Orientação aceita</Tag>;
                        case false:
                          return <Tag color='errorColor'>Orientação não aceita</Tag>;
                        default:
                          return <Tag color='primaryColor'>Seleção pendente</Tag>;
                      }
                    })()}
                  </StyledTags>
                </ListItemActions>
              </StyledItem>
            ))}
        </List>
      </>
    );
  }
}
